import {
  IGetRegionsDTO,
  IGetRegionSettlementsDTO,
  IGetRegionSettlementsResponse,
  IGetRegionsResponse,
  RegionsEndpoints,
  IAutocompleteRegionsDTO,
  IAutocompleteRegionsResponse,
  IAutocompleteSettlementsDTO,
  IAutocompleteSettlementsResponse,
} from '@/models/regions.model';
import { ApiResponse, httpClient } from '@/utils';

class RegionsAPI {
  static getRegions(data: IGetRegionsDTO): ApiResponse<IGetRegionsResponse> {
    return httpClient.get<IGetRegionsResponse>(RegionsEndpoints.REGIONS, { params: data });
  }

  static regionsAutoComplete(data: IAutocompleteRegionsDTO): ApiResponse<IAutocompleteRegionsResponse> {
    return httpClient.get<IAutocompleteRegionsResponse>(RegionsEndpoints.REGIONS_AUTOCOMPLETE, { params: data });
  }

  static settlementsAutoComplete(data: IAutocompleteSettlementsDTO): ApiResponse<IAutocompleteSettlementsResponse> {
    return httpClient.get<IAutocompleteSettlementsResponse>(RegionsEndpoints.SETTLEMENTS_AUTOCOMPLETE, {
      params: data,
    });
  }

  static regionToggleActive(id: string): ApiResponse<IGetRegionsResponse> {
    return httpClient.patch<IGetRegionsResponse>(`${RegionsEndpoints.REGIONS}/${id}/toggle-active`);
  }
  static getRegionSettlements(data: IGetRegionSettlementsDTO): ApiResponse<IGetRegionSettlementsResponse> {
    return httpClient.get<IGetRegionSettlementsResponse>(`${RegionsEndpoints.REGIONS}/${data.region_id}/settlements`, {
      params: data,
    });
  }
  static settlementToggleActive(id: string): ApiResponse<IGetRegionSettlementsResponse> {
    return httpClient.patch<IGetRegionSettlementsResponse>(`${RegionsEndpoints.SETTLEMENTS}/${id}/toggle-active`);
  }
  static settlementToggleHeader(id: string): ApiResponse<IGetRegionSettlementsResponse> {
    return httpClient.patch<IGetRegionSettlementsResponse>(`${RegionsEndpoints.SETTLEMENTS}/${id}/toggle-header`);
  }
}

export default RegionsAPI;
